<template>
  <div id="app" :class="mobile ? 'mobile' : ''">
    <router-view v-if="isRouterAlive" :key="new Date().getTime()"></router-view>
  </div>
</template>

<script>
  import { setRem } from '@/util/commen';
  export default {
    name: 'app',
    provide () {
      return {
        reload: this.reload
        
      }
    },
    data() {
      return {
        isRouterAlive:true,
        keepAlive: ['数据准备', '薪资明细'],
        mobile:false
      };
    },
    watch: {
    },
    created() {
      setRem()
      this.$store.commit('SET_CLIENT_WIDTH',document.body.clientWidth)
      this.$store.commit('SET_CLIENT_HEIGHT',document.body.clientHeight)
      this.$store.commit('SET_TABLE_SIZE')
      if (this._isMobile()) {
        this.mobile = true
        const deviceWidth = document.documentElement.clientWidth;
        document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px';
      } else {
        this.mobile = false
      }
    },
    methods: {
      reload () {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      },
      _isMobile(){
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        localStorage.setItem('ismobile', flag ? 1 : 0)
        return flag;
      }
    },
    computed: {},
  };
</script>
<style lang="scss">
  #app {
    width: 100%;
    height: 100%;
    &.mobile {
      background-color: #fff !important;
    }
  }
  .el-pagination {
    text-align: right;
    margin-top: 10px;
  }
</style>

